import { HttpIntegration } from "./HttpIntegration";

export default HttpIntegration;
